import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import TimeField from 'react-simple-timefield';
import clsx from 'clsx';
import axios from 'axios';
import moment from 'moment';

import { 
  Button, 
  Dialog, 
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // ListItemText, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  Switch,
  Backdrop,
  Card,
  CardHeader,
  //CardActions,
  CardContent,
  CircularProgress,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  FormControlLabel,
  Select,
  Chip,
  InputLabel,
  Box,
  Paper,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import TagFacesIcon from '@material-ui/icons/TagFaces';

import RefreshIcon from '@material-ui/icons/Refresh';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { /*agencies, clients, */areaStates } from 'common/datas';
import { IsNoU } from 'common/utils';
import { deviceVolumes } from 'common/datas';

import { SelectAgencyClient, SelectStartEndDate, SelectDistrict } from 'components';

const selectDeviceVolumes = [{ 
  value: '-1',
  label: '없음',
}, ...deviceVolumes];

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  templateTitle: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row_center: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  registerListItemTitle: {
    //marginLeft: theme.spacing(1),
    width: '120px',
  },
  registerListItemImageTitle: {
    marginLeft: theme.spacing(2),
    width: '204px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemAdress: {
    //marginLeft: theme.spacing(2),
    width: '120px',
    //height: '40px',
  },
  registerListItemAdress1: {
    //marginLeft: theme.spacing(2),
    width: '180px',
    //height: '40px',
  },
  registerListItemFilePath: {
    //marginLeft: theme.spacing(2),
    width: '360px',
  },
  registerListItemUpload: {
    marginLeft: theme.spacing(2),
  },
  registerListItemTitle1: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemTitle2: {
    marginLeft: theme.spacing(4),
    width: '100px',
  },
  registerListItemDateGap: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  registerListItemTailText: {
    marginLeft: theme.spacing(1),
  },
  formControl_Address: {
    margin: theme.spacing(0.8),
    marginLeft: theme.spacing(10),
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    width: '480px',
    minHeight: '40px',
//    padding: theme.spacing(0.5),
//    margin: 0,
//    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
 
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const RegAndEditAdvertise = (props) => {

  const classes = useStyles();

  const {
    className,
    openDialog,
    onClickCloseDialog,
    onClickSaveDialog,
    editAdvertise,
    modeRegisterDlg,
    userName,
    template,
    category,
    agencies,
    clients,
    //addresses,

    onSelectedAddress,
    address_sidoes,
    address_guguns,
//    address_dongs,
    address_roades,
    address_building_numbers,
    address_building_names,
    refresh_addresses,

    getPositionToAddress,
    position_to_address,

    loading_address,
  } = props;

  const [modifiedUser, setModifiedUser] = useState(userName);

  const [advertiseName, setAdvertiseName] = useState('');
  const [disabledAdvertiseName, setDisabledAdvertiseName] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState('');
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [prevVideoFile, setPrevVideoFile] = useState('');
  const [videoFileName, setVideoFileName] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  // const [prevAdImageFile, setPrevAdImageFile] = useState('');
  // const [adImageFileName, setAdImageFileName] = useState('');
  // const [adImageFile, setAdImageFile] = useState(null);
  const [prevImageFile, setPrevImageFile] = useState('');
  const [imageFileName, setImageFileName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [durationTime, setDurationTime] = useState(0);
  const [videoFileSize, setVideoFileSize] = useState(0);
  const [metadata, setMetadata] = useState(null);

  const [selectedVolume, setSelectedVolume] = useState(-1);

  const [payType, setPayType] = useState('normal');
  const [view_count, setViewCount] = useState(0);
  const [contractCost, setContractCost] = useState(0);

  const [selectedState, setSelectedState] = useState('');
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');

  const [districtSelects, setDistrictSelects] = useState([]);

  const [checkedImage, setCheckedImage] = useState(false);
  const [checkedTime, setCheckedTime] = useState(false);
  const [checkedArea, setCheckedArea] = useState(false);
  const [start_time, setStartTime] = useState('00:00');
  const [end_time, setEndTime] = useState('00:00');


  const [selectedSido, setSelectedSido] = useState('');
  const [selectedGugun, setSelectedGugun] = useState('');
//  const [selectedDong, setSelectedDong] = useState('');
  const [selectedRoad, setSelectedRoad] = useState('');
  const [selectedBuildingNumber, setSelectedBuildingNumber] = useState('');
  const [selectedBuildingName, setSelectedBuildingName] = useState('');

//  const [selected_xpos, set_selected_xpos] = useState('');
//  const [selected_ypos, set_selected_ypos] = useState('');

  let selected_xpos;
  let selected_ypos;


  const [openProgress, setOpenProgress] = useState(false);

  const handleChangeSwitchImage = name => event => {
//    console.log('handleChangeSwitchImage => '+event.target.checked);
    if (name!=='checkedImage') {
      setCheckedImage(!event.target.checked);
    }
    else {
      setCheckedImage(event.target.checked);
    }
  };

  const handleChangeSwitchTime = name => event => {
    if (name!=='checkedTime') {
      setCheckedTime(!event.target.checked);
    }
    else {
      setCheckedTime(event.target.checked);
    }
  };

  const handleChangeSwitchArea = name => event => {
    if (name!=='checkedArea') {
      setCheckedArea(!event.target.checked);
    }
    else {
      setCheckedArea(event.target.checked);
    }
  };

  const [agencyClients, setAgencyClients] = useState([]);
  const handleChangeAgency = e => {
    let newAgencyClients = clients.filter(client => client.agency === e.target.value);
    //console.log('new agency clients ->');
    //console.log(newAgencyClients);
    setAgencyClients(newAgencyClients);
    setSelectedClient('');
    setSelectedAgency(e.target.value);
  };

  const handleChangeClient = event => {
    setSelectedClient(event.target.value);
  };

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  const onTimeChange = name => (event, value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    if (name === 'start_time') {
      setStartTime(time);
    }
    else if (name === 'end_time') {
      setEndTime(time);
    }
  }

  const handleChangeState = event => {
    setSelectedState(event.target.value);

    const state = areaStates.find(state => (state.value === event.target.value));
    setDistricts(state.districts);

    setSelectedDistrict('');
    setDistrictSelects([]);
  };

  const getCheckedAdvertiseInfo = (template, category, name, video, image) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/advertise/advertise/check`,
      data: {
        template, 
        category, 
        name, 
        video, 
        image
      }
    });
  }

  const getCheckedPositionInfo = () => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/address/check`,
      data: {
        sido: selectedSido, 
        gugun: selectedGugun, 
//        dong: selectedDong, 
        road: selectedRoad, 
        building_number: selectedBuildingNumber,
        building_name: selectedBuildingName,
      }
    });
  }

  const handleSaveAdvertise = () => {

    let valueViewCount = 0;
    if (!IsNoU(view_count) && view_count.length > 0) {
      valueViewCount = Number(view_count.replace(/\D/g, ''));
    }
    
    let valueContractCost = 0;
    if (!IsNoU(contractCost) && contractCost.length > 0) {
      valueContractCost = Number(contractCost.replace(/\D/g, ''));
    }

    if (!modeRegisterDlg && !IsNoU(editAdvertise)) {
      setModifiedUser(editAdvertise.modified_user);
    }

//    console.log('template -> ' + template + ',' + selectedSido + selectedGugun)

    const newAdvertise = {
      template,
      type: valueContractCost > 0 ? 'normal' : 'free',
      category,
      name: advertiseName,
      prev_movie: prevVideoFile,
      movie: videoFileName,
      video_file: videoFile,
      video_file_size: videoFileSize,
      prev_image: prevImageFile,
      image: imageFileName,
      image_file: imageFile, 
      playtime: IsNoU(metadata) ? 0 :  Math.floor(metadata.duration),
      agency: selectedAgency,
      client: selectedClient,
      volume: selectedVolume,
      start_date: selectedStartDate,
      end_date: selectedEndDate,
      view_count: valueViewCount,
      cost: valueContractCost,
      start_time: start_time,
      end_time: end_time,
      xpos: (template === 'position') ? selected_xpos : '',
      ypos: (template === 'position') ? selected_ypos : '',
      welcome: (template === 'welcome') ? (selectedSido + "," + selectedGugun) : '',
      modified_user: modifiedUser,
      modified_at: new Date()
    };

    newAdvertise.image = (checkedImage || template === 'image') ? imageFileName : '' ;
    newAdvertise.start_time = checkedTime ? start_time : '' ;
    newAdvertise.end_time = checkedTime ? end_time : '' ;
    newAdvertise.area = checkedArea;
    newAdvertise.state = checkedArea ? selectedState : '' ;
    //console.log(JSON.stringify(districtSelects));
    newAdvertise.district = checkedArea ? JSON.stringify(districtSelects) : '[]';

    console.log(newAdvertise);
    onClickSaveDialog(newAdvertise);
  }

  const handleSavePositionAdvertise = async () => {
    const res_position = await getCheckedPositionInfo();
    console.log(res_position);

    if (!IsNoU(res_position) && !IsNoU(res_position.data) && !IsNoU(res_position.data.position)) {
      selected_xpos = res_position.data.position.xpos;
      selected_ypos = res_position.data.position.ypos;
    }
    else {
      toast("주소 정보를 찾을 수 없습니다.");
      return ;
    }

    handleSaveAdvertise();
  }

  const handleCheckAdvertise = async (template, category, name, video, image) => {

    if (template === 'position') {
      const res_position = await getCheckedPositionInfo();
      console.log(res_position);

      if (!IsNoU(res_position) && !IsNoU(res_position.data) && !IsNoU(res_position.data.position)) {
        // console.log(res_position.data.position.xpos);
        // console.log(res_position.data.position.ypos);
        selected_xpos = res_position.data.position.xpos;
        selected_ypos = res_position.data.position.ypos;
//        set_selected_xpos(res_position.data.position.xpos);
//        set_selected_ypos(res_position.data.position.ypos);
      }
      else {
        toast("주소 정보를 찾을 수 없습니다.");
        return ;
      }
    }

    const res = await getCheckedAdvertiseInfo(template, category, name, video, image);
    //console.log(res);
    const resultCheck = res.data.checked;
    //console.log(resultCheck);
    //setDisabledEditUserId(checkeduserid);
    setOpenProgress(false);
    if (resultCheck === 0) {
      handleSaveAdvertise();
    }
    else if (resultCheck === 1) {
       toast(advertiseName+"이/가 존재 합니다.");
    }
    else if (resultCheck === 2) {
      toast('동일한 '+video+'이/가 존재 합니다.');
    }
    else if (resultCheck === 3) {
      toast('동일한 '+image+'이/가 존재 합니다.');
    }
  }

  const handleDeleteDistrict = (chipToDelete) => () => {
    setDistrictSelects((chips) => chips.filter((chip) => chip !== chipToDelete));
  }

  useEffect(() => {
    //console.log('componentDidUpdate & editAdvertise changed');

    if (editAdvertise === null) {
        setAdvertiseName('');
        setPayType('normal');
        setDisabledAdvertiseName(false);
        setSelectedStartDate(new Date());
        setSelectedEndDate(new Date());
        setPrevVideoFile('');
        setVideoFile(null);
        setVideoFileName('');
        setVideoFileSize(0);
        setPrevImageFile('');
        setImageFile(null);
        setImageFileName('');
        setMetadata(null);
        setDurationTime(0);
        setViewCount(0);
        setContractCost(0);

        setCheckedImage(false);
        setCheckedTime(false);
        setCheckedArea(false);
        setSelectedState('');
        setSelectedDistrict('');
        setDistrictSelects([]);
        setStartTime('00:00');
        setEndTime('00:00');

        // if (!IsNoU(agencies) && agencies.length > 0) {
        //   setSelectedAgency(agencies[0].name);
        // }
        // else {
        setSelectedAgency('');
        // }

        // if (!IsNoU(clients) && clients.length > 0) {
        //   setSelectedClient(clients[0].name);
        // }
        // else {
        setSelectedClient('');
        // }

        setSelectedVolume(-1);
    }
    else {
      setAdvertiseName(editAdvertise.name);
      //console.log('ad paid type -> ' + editAdvertise.type);
      setPayType(editAdvertise.type);
      setDisabledAdvertiseName(true);
      // setSelectedAgency(editAdvertise.agency);
      // setSelectedClient(editAdvertise.client);
      if (!IsNoU(editAdvertise.agency)) {
        setSelectedAgency(editAdvertise.agency);

        let newAgencyClients = clients.filter(client => client.agency === editAdvertise.agency);
        //console.log('new agency clients ->');
        //console.log(newAgencyClients);
        setAgencyClients(newAgencyClients);
        if (!IsNoU(editAdvertise.client)) {
          setSelectedClient(editAdvertise.client);
        }
      }
      setSelectedVolume(editAdvertise.volume);
      setSelectedStartDate(editAdvertise.start_date);
      setSelectedEndDate(editAdvertise.end_date);
      setPrevVideoFile(editAdvertise.movie);
      setVideoFile(null);
      setVideoFileName('');
      setVideoFileSize(0);
      setPrevImageFile(editAdvertise.image);
      setImageFile(null);
      setImageFileName('');
      setMetadata(null);
      setDurationTime(0);
      setViewCount(editAdvertise.view_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      //setViewCount(editAdvertise.view_count);
      setContractCost(editAdvertise.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));

      setCheckedImage(!IsNoU(editAdvertise.image) && editAdvertise.image.length > 0);
      setCheckedTime(!IsNoU(editAdvertise.start_time) && editAdvertise.start_time.length > 0);
      //console.log(editAdvertise.area);
      setCheckedArea(!IsNoU(editAdvertise.area) && editAdvertise.area === 'true');
      //console.log(editAdvertise.state);
      if (!IsNoU(editAdvertise.state) && editAdvertise.state.length > 0) {
        setSelectedState(editAdvertise.state);
        const state = areaStates.find(state => (state.value === editAdvertise.state));
        //console.log('districts -> ');
        //console.log(state.districts);
        setDistricts(state.districts);
      }
      setSelectedDistrict('');
      //console.log('districts -> ' + editAdvertise.district.length);
      //console.log(editAdvertise.district);
      //setDistrictSelects(IsNoU(editAdvertise.district) || editAdvertise.district.length <= 0 ? [] : JSON.parse(editAdvertise.district));
      setDistrictSelects(IsNoU(editAdvertise.district) ? [] : editAdvertise.district);
      setStartTime(!IsNoU(editAdvertise.start_time) && editAdvertise.start_time.length > 0 ? editAdvertise.start_time : '00:00');
      setEndTime(!IsNoU(editAdvertise.end_time) && editAdvertise.end_time.length > 0 ? editAdvertise.end_time : '23:59');

      selected_xpos = '';
      selected_ypos = '';

      setSelectedSido('');
      setSelectedGugun('');
//      setSelectedDong('');
      setSelectedRoad('');
      setSelectedBuildingNumber('');
      setSelectedBuildingName('');

      if (template === 'position') {
        if (!IsNoU(editAdvertise.xpos) && !IsNoU(editAdvertise.ypos))
          getPositionToAddress(editAdvertise.xpos, editAdvertise.ypos)
      }
      if (template === 'welcome' && !IsNoU(editAdvertise.welcome)) {
        const addresses = editAdvertise.welcome.split(',');
        if (addresses.length > 1) {
          setSelectedSido(addresses[0]);
          setSelectedGugun(addresses[1]);
        }
      }
    }

  }, [editAdvertise]);

  useEffect(() => {
    // console.log('update open dialog ->');
    // console.log(openDialog);
    // console.log('update open dialog ->');
    // console.log(editAdvertise);
    if (openDialog && IsNoU(editAdvertise)) {
      setAdvertiseName('');
      setPayType('normal');
      setDisabledAdvertiseName(false);
      setSelectedStartDate(new Date());
      setSelectedEndDate(new Date());
      setPrevVideoFile('');
      setVideoFile(null);
      setVideoFileName('');
      setVideoFileSize(0);
      setPrevImageFile('');
      setImageFile(null);
      setImageFileName('');
      setMetadata(null);
      setDurationTime(0);
      setViewCount(0);
      setContractCost(0);

      setCheckedImage(false);
      setCheckedTime(false);
      setCheckedArea(false);
      setSelectedState('');
      setSelectedDistrict('');
      setDistrictSelects([]);
      setStartTime('00:00');
      setEndTime('00:00');
      setSelectedAgency('');
      setSelectedClient('');

      selected_xpos = '';
      selected_ypos = '';

      setSelectedSido('');
      setSelectedGugun('');
//      setSelectedDong('');
      setSelectedRoad('');
      setSelectedBuildingNumber('');
      setSelectedBuildingName('');
    }
  }, [openDialog]);

  useEffect(() => {
    if (template === 'position') {
      // console.log('update pos to addr ->')
      // console.log(position_to_address);
      setSelectedSido(position_to_address.sido);
      setSelectedGugun(position_to_address.gugun);
//      setSelectedDong(position_to_address.dong);
      setSelectedRoad(position_to_address.road);
      setSelectedBuildingNumber(position_to_address.building_number);
      setSelectedBuildingName(position_to_address.building_name);
    }
  }, [position_to_address]);

  useEffect(() => {
    setOpenProgress(loading_address);
  }, [loading_address]);

  const renderVideoInput = (
    <>
      <TextField 
        className={classes.registerListItemInput}
        required 
        id="id_ad_file" 
        //variant="outlined" 
        label="동영상 첨부"
        //placeholder="플레이어 이름을 입력하세요..."
        fullWidth
        value={videoFileName}
        disabled={true}
        //onChange={event=> setPlayerName(event.target.value)}
        />
      <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
      >
        파일선택
        <input
          type="file"
          accept="video/mp4"
          style={{ display: "none" }}
          onChange={e => {
            const file = e.target.files[0];
            if (file !== null && file !== undefined) {
              setVideoFileName(file.name);
              setVideoFileSize(file.size);
              setVideoFile(file);
            }
            console.log(file);
          }}
        />
      </Button>
      {videoFile && (
        <video
          controls={true}
          width="100"
          style={{ display: "none" }}
          onLoadedMetadata={e => {
            setDurationTime(e.target.duration);
            setMetadata({
              videoHeight: e.target.videoHeight,
              videoWidth: e.target.videoWidth,
              duration: e.target.duration
            });
          }}
        >
          <source src={URL.createObjectURL(videoFile)} 
            type="video/mp4" />
        </video>
      )}
    </>
  );

  const renderImageInput = (
    <>
      <TextField
        className={classes.registerListItemFilePath}
        id="outlined-basic2" 
        label="이미지 첨부"
        //variant="outlined" 
        //value={videoFile.name}
        value={imageFileName}
        margin="dense"
        disabled={true}/>
      <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
      >
        파일선택
        <input
          type="file"
          accept="image/x-png,image/jpeg"
          style={{ display: "none" }}
          onChange={e => {
            const file = e.target.files[0];
            if (file !== null && file !== undefined) {
            setImageFileName(file.name);
            setImageFile(file);
            }
          }}
        />
      </Button>
    </>
  );

  const renderLayoutInput = (
    <>
      <ListItem>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          화면레이아웃
        </Typography>
      </ListItem>
      <ListItem>
      <FormControlLabel
          control={
            <Switch
              checked={!checkedImage}
              onChange={handleChangeSwitchImage('checkedNone')}
              value="checkedImage"
              color="primary"
            />
          }
          label="전체화면"
        />
        <FormControlLabel
          control={
            <Switch
              checked={checkedImage}
              onChange={handleChangeSwitchImage('checkedImage')}
              value="checkedImage"
              color="primary"
            />
          }
          label="이미지"
        />
      </ListItem>
      <ListItem>
        <TextField
          className={classes.registerListItemFilePath}
          id="outlined-basic2" 
          //variant="outlined" 
          //value={videoFile.name}
          value={imageFileName}
          margin="dense"
          disabled={true}/>
        <Button
          className={classes.registerListItemUpload}
          variant="contained"
          component="label"
          disabled={!checkedImage}
        >
          파일선택
          <input
            type="file"
            accept="image/x-png,image/jpeg"
            style={{ display: "none" }}
            onChange={e => {
              const file = e.target.files[0];
              if (file !== null && file !== undefined) {
                setImageFileName(file.name);
                setImageFile(file);
              //console.log(file);
              }
            }}
          />
        </Button>
      </ListItem>
    </>
  );

  const renderPlayTime = (
      <TextField 
        className={classes.registerListItemInput}
        required 
        id="id_ad_playtime" 
        //variant="outlined" 
        label="재생 시간"
        //placeholder="플레이어 이름을 입력하세요..."
        fullWidth
        value={Math.floor(durationTime) + '초'}
        disabled={true}
        //onChange={event=> setPlayerName(event.target.value)}
        />
  );

  const renderPositionAddress = (
    <>
    <ListItem>
    <TextField
      className={classes.registerListItemAdress}
      required 
      id="id-select-address-sido"
      label="시/도"
      select
      value={selectedSido}
      //onChange={e => setSelectedVolume(e.target.value)}
      onChange={e => {setSelectedSido(e.target.value); onSelectedAddress('gugun', e.target.value);}}
      //variant="outlined"
      margin="dense"
    >
      {address_sidoes.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>
      <Box padding={1}></Box>
    <TextField
      className={classes.registerListItemAdress}
      required 
      id="id-select-address-gugun"
      label="구/군"
      select
      value={selectedGugun}
      //onChange={e => setSelectedVolume(e.target.value)}
      onChange={e => {setSelectedGugun(e.target.value); onSelectedAddress('road', selectedSido, e.target.value)}}
      //variant="outlined"
      margin="dense"
    >
      {address_guguns.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>
    <Box padding={1}></Box>
    {/* <TextField
      className={classes.registerListItemAdress}
      required 
      id="id-select-address-dong"
      label="동"
      select
      value={selectedDong}
      //onChange={e => setSelectedVolume(e.target.value)}
      onChange={e => {setSelectedDong(e.target.value); onSelectedAddress('road', selectedSido, selectedGugun, e.target.value)}}
      //variant="outlined"
      margin="dense"
    >
      {address_dongs.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField> */}

    <TextField
      className={classes.registerListItemAdress1}
      required 
      id="id-select-address-gil"
      label="도로명"
      select
      value={selectedRoad}
      //onChange={e => setSelectedVolume(e.target.value)}
      //onChange={e => {setSelectedRoad(e.target.value); onSelectedAddress('building_number', selectedSido, selectedGugun, selectedDong, e.target.value)}}
      onChange={e => {setSelectedRoad(e.target.value); onSelectedAddress('building_number', selectedSido, selectedGugun, e.target.value)}}
      //variant="outlined"
      margin="dense"
    >
      {address_roades.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>

    </ListItem>
    <ListItem>

    <TextField
      className={classes.registerListItemAdress}
      //required 
      id="id-select-address-build-number"
      label="건물번호"
      select
      value={selectedBuildingNumber}
      //onChange={e => setSelectedVolume(e.target.value)}
      //onChange={e => {setSelectedBuildingNumber(e.target.value); onSelectedAddress('building_name', selectedSido, selectedGugun, selectedDong, selectedRoad, e.target.value)}}
      onChange={e => {setSelectedBuildingNumber(e.target.value); onSelectedAddress('building_name', selectedSido, selectedGugun, selectedRoad, e.target.value)}}
      //variant="outlined"
      margin="dense"
    >
      {address_building_numbers.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>
    <Box padding={1}></Box>
    <TextField
      className={classes.registerListItemAdress}
      //required 
      id="id-select-address-build-number"
      label="건물이름"
      select
      value={selectedBuildingName}
      onChange={e => setSelectedBuildingName(e.target.value)}
      //variant="outlined"
      margin="dense"
    >
      {address_building_names.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>

    <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
        onClick={ () => {
          setSelectedSido('');
          setSelectedGugun('');
//          setSelectedDong('');
          setSelectedRoad('');
          setSelectedBuildingNumber('');
          setSelectedBuildingName('');
          refresh_addresses()
        } }
      >
        다시선택
      </Button>
    </ListItem>
    </>
);

  const renderMoveArea = (
    <>
    <ListItem>
    <TextField
      className={classes.registerListItemAdress}
      required 
      id="id-select-address-sido"
      label="시/도"
      select
      value={selectedSido}
      //onChange={e => setSelectedVolume(e.target.value)}
      onChange={e => {setSelectedSido(e.target.value); onSelectedAddress('gugun', e.target.value);}}
      //variant="outlined"
      margin="dense"
    >
      {address_sidoes.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>
      <Box padding={1}></Box>
    <TextField
      className={classes.registerListItemAdress}
      required 
      id="id-select-address-gugun"
      label="구/군"
      select
      value={selectedGugun}
      //onChange={e => setSelectedVolume(e.target.value)}
      onChange={e => {setSelectedGugun(e.target.value);}}
      //variant="outlined"
      margin="dense"
    >
      {address_guguns.map(obj => (
        <MenuItem key={obj} value={obj}>
          {obj}
        </MenuItem>
      ))}
    </TextField>
    <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
        onClick={ () => {
          setSelectedSido('');
          setSelectedGugun('');
//          setSelectedDong('');
          setSelectedRoad('');
          setSelectedBuildingNumber('');
          setSelectedBuildingName('');
          refresh_addresses()
        } }
      >
        다시선택
      </Button>
    </ListItem>
    </>
  );

  const renderSelectVolume = (
    <TextField
      className={classes.registerListItemInput}
      id="id-select-volume"
      label="볼륨"
      select
      value={selectedVolume}
      onChange={e => setSelectedVolume(e.target.value)}
      //variant="outlined"
      margin="dense"
    >
      {selectDeviceVolumes.map(obj => (
        <MenuItem key={obj.value} value={obj.value}>
          {obj.label}
        </MenuItem>
      ))}
    </TextField>
  );

  const renderPrevVideoFile = (
    <>
      <TextField 
        className={classes.registerListItemFilePath}
        id="outlined-basic1" 
        label="기존 동영상"
        //variant="outlined" 
        value={prevVideoFile}
        //onChange={event=> setPlayerName(event.target.value)}
        margin="dense"
        disabled={true}/>
    </>
  );

  const renderNewVideoInput = (
    <>
      <TextField
        className={classes.registerListItemFilePath}
        id="outlined-basic2" 
        label="동영상 첨부"
        //variant="outlined" 
        value={videoFileName}
        disabled={true}
        helperText="기존등록파일명이 같을경우 신규수정파일 등록 불가 합니다"
        margin="dense"/>
      <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
      >
        파일선택
        <input
          type="file"
          accept="video/mp4"
          style={{ display: "none" }}
          onChange={e => {
            const file = e.target.files[0];
            //console.log(prevVideoFile);
            if (file !== null && file !== undefined) {
              let fileName = file.name.toString();
              let prevName = undefined;
              if (!IsNoU(prevVideoFile) && prevVideoFile.length > 0) {
                prevName = prevVideoFile.toString();
              }
              if (!IsNoU(prevName) && fileName === prevName) {
                toast('기존 등록 동영상 파일명과 동일합니다.');
              }
              else {
                setVideoFileName(file.name);
                setVideoFileSize(file.size);
                setVideoFile(file);
              }
            }
            //console.log(file);
          }}
        />
      </Button>

      {videoFile && (
        <video
          controls={true}
          width="100"
          style={{ display: "none" }}
          onLoadedMetadata={e => {
            setDurationTime(e.target.duration);
            setMetadata({
              videoHeight: e.target.videoHeight,
              videoWidth: e.target.videoWidth,
              duration: e.target.duration
            });
          }}
        >
          <source src={URL.createObjectURL(videoFile)} 
            type="video/mp4" />
        </video>
      )}
    </>
  );

  const renderNewLayoutInput = (
    <>
      <ListItem>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          화면레이아웃
        </Typography>
      </ListItem>
      <ListItem>
        <FormControlLabel
          control={
            <Switch
              checked={!checkedImage}
              onChange={handleChangeSwitchImage('checkedNone')}
              value="checkedImage"
              color="primary"
            />
          }
          label="전체화면"
        />
        <FormControlLabel
          control={
            <Switch
              checked={checkedImage}
              onChange={handleChangeSwitchImage('checkedImage')}
              value="checkedImage"
              color="primary"
            />
          }
          label="이미지"
        />
      </ListItem>
      <ListItem>
        <TextField
          className={classes.registerListItemFilePath}
          id="outlined-basic2" 
          //variant="outlined" 
          //value={videoFile.name}
          value={prevImageFile}
          margin="dense"
          disabled={true}/>
      </ListItem>
      <ListItem>
        <TextField
          className={classes.registerListItemFilePath}
          id="outlined-basic2" 
          //variant="outlined" 
          //value={videoFile.name}
          value={imageFileName}
          margin="dense"
          helperText="기존등록파일명이 같을경우 신규수정파일 등록 불가 합니다"
          disabled={true}/>
        <Button
          className={classes.registerListItemUpload}
          variant="contained"
          component="label"
          disabled={!checkedImage}
        >
          파일선택
          <input
            type="file"
            accept="image/x-png,image/jpeg"
            style={{ display: "none" }}
            onChange={e => {
              const file = e.target.files[0];
              if (file !== null && file !== undefined) {
                let fileName = file.name.toString();
                let prevName = undefined;
                if (!IsNoU(prevImageFile) && prevImageFile.length > 0) {
                  prevName = prevImageFile.toString();
                }
                if (!IsNoU(prevName) && fileName === prevName) {
                  toast('기존 등록 이미지 파일명과 동일합니다.');
                }
                else {
                  setImageFileName(file.name);
                  setImageFile(file);
                }
                
              //console.log(file);
              }
            }}
          />
        </Button>
      </ListItem>
      <Divider />
    </>
  );

  const renderViewCountInput = (
    <div className={classes.row}>
      <TextField 
        className={classes.registerListItemInput}
        id="id_view_count" 
        label="전체뷰카운트"
        //variant="outlined"
        inputProps={{
          style: { textAlign: "right" }
        }}
        //type="number"
        value={view_count}
        onChange={(e) => {
            const re = /^[0-9\b]+$/;
            const value = Number(e.target.value.replace(/\D/g, ''));
            // if value is not blank, then test the regex
            if (e.target.value === '' || re.test(value)) {
              setViewCount(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
        }}
        margin="dense" />
      회
    </div>
  );

  const renderPaidTypeSelectInput = (
    <ListItem>
      <FormControl>
        <FormLabel component="legend">광고유형</FormLabel>
        <RadioGroup 
          row aria-label="pay_type"
          name="" 
          value={payType} 
          onChange={(e) => setPayType(e.target.value)} >
          <FormControlLabel value="normal" control={<Radio color="primary" />} label="유료" />
          <FormControlLabel value="free" control={<Radio color="primary" />} label="무료" />
        </RadioGroup>
      </FormControl>
      {/* <div className={classes.row}>
        <div>원</div>
      </div> */}
    </ListItem>
  );

  const renderContactPriceInput = (
    <div className={classes.row}>
      <TextField 
        className={classes.registerListItemInput}
        id="id_contact_cost" 
        label="계약금액"
        //variant="outlined" 
        inputProps={{
          style: { textAlign: "right" }
        }}
        value={contractCost}
        onChange={(e) => {
          const re = /^[0-9\b]+$/;
          const value = Number(e.target.value.replace(/\D/g, ''));
          // if value is not blank, then test the regex
          if (e.target.value === '' || re.test(value)) {
            setContractCost(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          }
        }}
        margin="dense" />
      <div className={classes.row_center}>
        <div>원</div>
      </div>
    </div>
  );

  const renderTermPlayTimeInput = (
    <>
    <ListItem>
      <Typography
        className={classes.registerListItemTitle}
        color="textSecondary"
        gutterBottom
      >
        플레이 시간대
      </Typography>
    </ListItem>
    <ListItem>
      <FormControlLabel
        control={
          <Switch
            checked={!checkedTime}
            onChange={handleChangeSwitchTime('checkedNone')}
            value="checkedTime"
            color="primary"
          />
        }
        label="All"
      />
      <FormControlLabel
        control={
          <Switch
            checked={checkedTime}
            onChange={handleChangeSwitchTime('checkedTime')}
            value="checkedTime"
            color="primary"
          />
        }
        label="시간설정"
      />

      <TimeField
        value={start_time}
        onChange={onTimeChange('start_time')}
        style={{width: 88}}
        input={
          <TextField 
            value={start_time} 
            //variant="outlined" 
            margin="dense"/>
        }
        disabled={!checkedTime}
      />
      ~
      <TimeField
        value={end_time}
        onChange={onTimeChange('end_time')}
        style={{width: 88}}
        input={
          <TextField 
            value={end_time} 
            //variant="outlined" 
            margin="dense"/>
        }
        disabled={!checkedTime}
      />
      </ListItem>
    </>
  );

  const renderSelectAreaInput = (
    <>
      <ListItem>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          지역선택
        </Typography>
      </ListItem>
      <ListItem>
        <FormControlLabel
          control={
            <Switch
              checked={!checkedArea}
              onChange={handleChangeSwitchArea('checkedNone')}
              value="checkedArea"
              color="primary"
            />
          }
          label="All"
        />
      </ListItem>
      <ListItem>
        <FormControlLabel
          control={
            <Switch
              checked={checkedArea}
              onChange={handleChangeSwitchArea('checkedArea')}
              value="checkedArea"
              color="primary"
            />
          }
          label="행정구역"
        />

        <TextField
          className={classes.registerListItemInput}
          id="outlined-select-state"
          label="시/도"
          select
          value={selectedState}
          onChange={handleChangeState}
          //variant="outlined"
          margin="dense"
          disabled={!checkedArea}
        >
          {areaStates.map(state => (
            <MenuItem key={state.value} value={state.value}>
              {state.value}
            </MenuItem>
          ))}
        </TextField>

        <Box padding={1}></Box>

        <TextField
          className={classes.registerListItemInput}
          id="outlined-select-district"
          label="구/군"
          select
          value={selectedDistrict}
          onChange={e => { 
            setSelectedDistrict(e.target.value);
            let find_value = districtSelects.find(district => {
              return district.district === e.target.value;
            });
            //console.log('find_value -> ' + find_value);
            if (IsNoU(find_value))
              setDistrictSelects([...districtSelects, {state:selectedState, district:e.target.value}]);
          }}
          //variant="outlined"
          margin="dense"
          disabled={!checkedArea}
        >
          {districts.map(district => (
            <MenuItem key={district.value} value={district.value}>
              {district.label}
            </MenuItem>
          ))}
        </TextField>
      </ListItem>
      <ListItem>
      <Paper component="ul" className={classes.formControl_Address}>
          {districtSelects.map(district => (
            <li key={district.district}>
              <Chip
                //icon={<TagFacesIcon />}
                label={district.district}
                onDelete={handleDeleteDistrict(district)}
                className={classes.chip}
              />
            </li>
          ))}
        </Paper>
      </ListItem>
    </>
  );

  return (
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" className={classes.title} color="inherit">
            {/* {modeRegisterDlg ? `${category} 등록` : `${category} 수정`} */}
            {category}
          </Typography>
          <Button autoFocus color="inherit" onClick={() => {

              if (IsNoU(advertiseName) || advertiseName.length <= 0) {
                toast("광고명을 입력하세요.");
                return ;
              }

              if (template !== 'image') {
                if (IsNoU(videoFileName) || videoFileName.length <= 0) {
                  toast("동영상 파일을 선택하세요.");
                  return ;
                }

                if (template === 'position') {
                  if (IsNoU(selectedSido) || selectedSido.length <= 0) {
                    toast("시/도 주소를 선택하세요.");
                    return ;
                  }
                  if (IsNoU(selectedGugun) || selectedGugun.length <= 0) {
                    toast("구/군 주소를 선택하세요.");
                    return ;
                  }
                  // if (IsNoU(selectedDong) || selectedDong.length <= 0) {
                  //   toast("동 주소를 선택하세요.");
                  //   return ;
                  // }
                  if (IsNoU(selectedRoad) || selectedRoad.length <= 0) {
                    toast("도로명 주소를 선택하세요.");
                    return ;
                  }
                }
                else if (template === 'normal' || template === 'free' ) { 
                  if (checkedImage) {
                    if (IsNoU(imageFileName) || imageFileName.length <= 0) {
                      toast('이미지 파일을 선택하세요.');
                      return ;
                    }
                  }
                }
              }
              else if (template === 'image'){
                if (IsNoU(imageFileName) || imageFileName.length <= 0) {
                  toast('이미지 파일을 선택하세요.');
                  return ;
                }
              }

              if (IsNoU(selectedAgency) || selectedAgency.length <= 0) {
                toast("광고대행사를 선택하세요.");
                return ;
              }

              if (IsNoU(selectedClient) || selectedClient.length <= 0) {
                toast("광고주를 선택하세요.");
                return ;
              }
              

              // if ((moment(new Date()).isAfter(selectedStartDate, 'year') ||
              //     moment(new Date()).isAfter(selectedStartDate, 'month') ||
              //     moment(new Date()).isAfter(selectedStartDate, 'day')) || 
              //     (moment(new Date()).isSame(selectedStartDate, 'day'))) {
              //   toast("시작 날짜를 금일 이후로 선택하세요.");
              //   return ;
              // }
              // else 
              {
                // if (moment(selectedStartDate).isSame(selectedEndDate, 'day')) {

                // }
                // else 
                if ((moment(selectedStartDate).isAfter(selectedEndDate, 'year') ||
                  moment(selectedStartDate).isAfter(selectedEndDate, 'month') ||
                  moment(selectedStartDate).isAfter(selectedEndDate, 'day'))) {
                  toast("종료 날짜를 시작일 이후로 선택하세요.");
                  return ;
                }
              }

              if (IsNoU(view_count) || view_count.length <= 0) {
                toast("전체 뷰 카운트를 입력하세요.");
                return ;
              }
  
              if (IsNoU(contractCost) || contractCost.length <= 0) {
                toast("계약금액을 입력하세요.");
                return ;
              }

              if (checkedTime) {
                // if (IsNoU(imageFileName) || imageFileName.length <= 0) {
                //   toast('이미지 파일을 선택하세요.');
                //   return ;
                // }
              }

              if (checkedArea) {
                if (IsNoU(selectedState) || selectedState.length <= 0) {
                  toast('행정구역 시/도를 선택하세요.');
                  return ;
                }

                if (districtSelects.length <= 0) {
                  toast('행정구역 구/군을 선택하세요.');
                  return ;
                }
              }
  
              setOpenProgress(true);
              if (!IsNoU(editAdvertise)) {
                if (template === 'position') {
                  handleSavePositionAdvertise();
                }
                else {
                  handleSaveAdvertise();
                }
              }
              else {
                handleCheckAdvertise(template, category, advertiseName, videoFileName, imageFileName);
              }
              
          }}>
            저장
          </Button>
        </Toolbar>
      </AppBar>

      <List>
        <ListItem>
          <Card
            className={clsx(classes.card_root, className)}
          >
            <CardHeader
              className={classes.card_header}
              title={modeRegisterDlg ? `${category} 등록` : `${category} 수정`}
              subheader='*표시는 필수 항목'
            />
            <CardContent className={classes.content}>
              <List>
                <ListItem className={classes.listitem_align}>
                <TextField 
                  className={classes.registerListItemInput}
                  required 
                  id="id_name_input" 
                  //variant="outlined" 
                  label="광고명"
                  placeholder="광고명을 입력하세요..."
                  fullWidth
                  value={advertiseName}
                  disabled={disabledAdvertiseName}
                  onChange={(e) => setAdvertiseName(e.target.value)}
                  />
                </ListItem>
                <Divider />
                {modeRegisterDlg ?
                (
                  <>
                    <ListItem>
                      { template !== 'image' ? renderVideoInput : renderImageInput }
                    </ListItem>
                      { template !== 'image' && (template === 'normal' || template === 'free') && ( <Divider /> ) }
                      { template !== 'image' && (template === 'normal' || template === 'free') && renderLayoutInput }
                      { template !== 'image' && (template === 'normal' || template === 'free') && ( <Divider /> ) }
                      { template !== 'image' && <ListItem> { renderPlayTime } </ListItem> }

                      { /* 위치 기반 광고 */}
                      { template === 'position' && ( <Divider /> ) }
                      { template === 'position' && renderPositionAddress }

                      { /* 지역 변경 광고 */}
                      { template === 'welcome' && ( <Divider /> ) }
                      { template === 'welcome' && renderMoveArea }

                  </>
                )
                :
                (
                  <>
                    <ListItem>
                      { renderPrevVideoFile }
                    </ListItem>
                    <ListItem>
                      { renderNewVideoInput }
                    </ListItem>
                    <Divider />
                    {(template === 'normal' || template === 'free') && renderNewLayoutInput }
                    <ListItem>
                      { renderPlayTime }
                    </ListItem>

                    { /* 위치 기반 광고 */}
                    { template === 'position' && ( <Divider /> ) }
                    { template === 'position' && renderPositionAddress }

                    { /* 지역 변경 광고 */}
                    { template === 'welcome' && ( <Divider /> ) }
                    { template === 'welcome' && renderMoveArea }
                  </>
                )}
                {template === 'top' && (
                  <>
                    <Divider />
                    <ListItem>
                      { renderSelectVolume }
                    </ListItem>
                  </>
                )}
                <Divider />
                  <ListItem>
                    <SelectAgencyClient 
                      agencies={agencies}
                      clients={agencyClients}
                      valueAgency={selectedAgency}
                      onChangeAgency={handleChangeAgency}
                      valueClient={selectedClient}
                      //onSetValueClient={client => setSelectedClient(client)}
                      onChangeClient={handleChangeClient}
                      />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <SelectStartEndDate
                      dateTitle={'광고기간'}
                      valueStartDate={selectedStartDate}
                      onChangeStartDate={handleStartDateChange}
                      valueEndDate={selectedEndDate}
                      onChangeEndDate={handleEndDateChange}
                      />
                  </ListItem>
                  <Divider />
                  {/* { template === 'image' && renderPaidTypeSelectInput } */}
                  {(template === 'default' || template === 'normal') && (
                      <>
                        { renderTermPlayTimeInput }
                        <Divider />
                      </>
                  )}
                  { template !== 'free' && ( renderPaidTypeSelectInput ) }
                  {/* { template === 'image' && (<Divider />) } */}
                  { template !== 'free' && ( 
                    <ListItem>
                    { renderViewCountInput }{ renderContactPriceInput }
                    </ListItem>
                  )}
                  <Divider />
                  {(template === 'normal') && (
                    <>
                      { renderSelectAreaInput }
                      <Divider />
                    </>
                  )}
              </List>
            </CardContent>
            </Card>
        </ListItem>
      </List>

      <Backdrop className={classes.backdrop} open={openProgress} /* onClick={handleClose} */>
        <CircularProgress color="inherit" />
      </Backdrop>

    </Dialog>
  );
}

export default RegAndEditAdvertise;